import { render, staticRenderFns } from "./ClassInformation.vue?vue&type=template&id=c11fcb02"
import script from "./ClassInformation.vue?vue&type=script&lang=js"
export * from "./ClassInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports